import { Component, Injector, Input, OnInit } from '@angular/core';
import { MinDTO } from 'src/app/models/min-dto';
import { SearchLogClickHistoryModel } from 'src/app/models/search-log-click-history.model';
import { SearchLogCommentModel } from 'src/app/models/search-log-comment.model';
import { SearchLogClickHistoryService } from 'src/app/services/search-log-click-history.service';

@Component({
  selector: 'app-price-rate',
  templateUrl: './price-rate.component.html',
  styleUrls: ['./price-rate.component.scss']
})
export class PriceRateComponent implements OnInit {

  @Input("model") history: SearchLogClickHistoryModel;
  loading: boolean = false;
  model: SearchLogCommentModel = new SearchLogCommentModel();
  score: number = 0;
  comment: string = null;
  constructor(protected injector: Injector, private searchlogClickHistoryService: SearchLogClickHistoryService) {

  }

  async ngOnInit() {
    const logHistory = new MinDTO();
    logHistory.id = this.history?.id
    logHistory.name = this.history?.productName;
    this.model.marketSearchLogClickHistory = logHistory;
  }

  async sendComment() {
    if(this.model.marketSearchLogClickHistory && this.model.marketSearchLogClickHistory.id) {
      try {
        this.loading = true;
        this.model = await this.searchlogClickHistoryService.comment(this.model).toPromise();
        this.model.created = true;
        this.loading = false;
      } catch {
        this.loading = false;
      }
        
    }
  }
  async handleRate(event: any) {
    await  this.searchlogClickHistoryService.comment(this.model).toPromise();

    setTimeout(() => {
      const dialogContent = document.querySelector('.p-dialog-content');
      if (dialogContent) {
          dialogContent.scrollTo({
              top: dialogContent.scrollHeight,
              behavior: 'smooth'
          });
      }
    }, 200)
  }
}
